module.exports = __webpack_public_path__ + "img/zachary-taylor.4aa66cc9.png";